<template>

    <div class="main">

        <escola></escola>

    </div>

</template>
<script>

import escola from '@/components/home/escola'
import smed from '@/components/home/smed'

export default {
    data () {
      return {
        text: ''
      }
    },
    methods:{
        load(){  }
    },
    components:{ escola, smed }
}
</script>
